import {isNotNil} from 'ramda';

import {
  PRESET_CONTROLLED_FORM_FIELDS,
  type PresetControlledFormField,
} from './presetFieldResolvers';

export {PRESET_CONTROLLED_FORM_FIELDS, type PresetControlledFormField};

const PRESET_CONTROLLED_FORM_FIELD_SET = new Set<string>(PRESET_CONTROLLED_FORM_FIELDS);

export function isPresetControlledFormField(
  fieldName: string | undefined
): fieldName is PresetControlledFormField {
  return isNotNil(fieldName) && PRESET_CONTROLLED_FORM_FIELD_SET.has(fieldName);
}
